import React, { useEffect, useState } from 'react';
import _uniqueId from 'lodash/uniqueId';
import CheckboxOnly from './CheckboxOnly';
import CheckboxItem from './CheckboxItem';
import CheckboxSelect from './CheckboxSelect';
import './checkbox.scss';

export const Checkbox = ({
    disabled = false,
    error = false,
    id,
    indeterminate = false,
    inputRef,
    label,
    name,
    onChange,
    onClick,
    onKeyDown,
    required,
    role,
    size,
    value,
    variant = 'item',
}) => {

    const [uId] = useState(_uniqueId('checkbox-'));
    const fieldId = id ? id : uId;

    return (<>
        {variant === 'checkbox' &&
            <CheckboxOnly
                disabled={disabled}
                error={error}
                id={fieldId}
                indeterminate={indeterminate}
                label={label}
                name={name}
                onClick={onClick}
                onChange={onChange}
                onKeyDown={onKeyDown}
                inputRef={inputRef}
                required={required}
                size={size}
                value={value}
            />
        }
        {variant === 'item' && 
            <CheckboxItem
                disabled={disabled}
                error={error}
                id={fieldId}
                indeterminate={indeterminate}
                label={label}
                name={name}
                onClick={onClick}
                onChange={onChange}
                onKeyDown={onKeyDown}
                inputRef={inputRef}
                required={required}
                role={role}
                size={size}
                value={value}
            />
        }
        {variant === 'select' &&
            <CheckboxSelect
                disabled={disabled}
                error={error}
                id={fieldId}
                indeterminate={indeterminate}
                label={label}
                name={name}
                onClick={onClick}
                onChange={onChange}
                onKeyDown={onKeyDown}
                inputRef={inputRef}
                required={required}
                role={role}
                size={size}
                value={value}
            />
        }
    </>)
}